import customerListComponent from './customer-list.component';

const customerListModule = angular.module('customerList', [
])
  .component('customerList', customerListComponent)
  .name;

export default customerListModule;
